<!--wrapping div required: https://github.com/jtblin/angular-chart.js/issues/29-->
<div class="flex-1 h-full max-w-full">
  <canvas #chart></canvas>
</div>
